<script setup>
import HomePage from '@/components/HomePage.vue';

</script>

<template>
  <Suspense>
    <HomePage />
  </Suspense>
</template>
